<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.74011 0C10.4151 0 12.0901 0.636 13.3672 1.907V5H4.11305V1.907C5.39114 0.636 7.06511 0 8.74011 0ZM13.3672 7.49977V5.99977H4.11305V7.49977C4.11305 9.37177 5.28935 10.9748 6.96229 11.6528C7.50931 11.8748 8.1098 11.9998 8.74011 11.9998C9.37041 11.9998 9.9709 11.8748 10.5179 11.6528C12.1898 10.9748 13.3672 9.37177 13.3672 7.49977ZM8.74 15.0004C7.32001 15.0004 6.16941 14.1044 6.16941 13.0004H5.14118V15.0514C6.31336 15.2834 7.19765 16.2924 7.19765 17.5004V19.5004C7.19765 20.2154 6.87478 20.8984 6.31234 21.3774C6.21465 21.4594 6.09435 21.5004 5.97405 21.5004C5.83112 21.5004 5.6882 21.4424 5.58743 21.3294C5.40029 21.1214 5.42291 20.8054 5.63679 20.6234C5.97508 20.3364 6.16941 19.9264 6.16941 19.5004V17.5004C6.16941 16.6734 5.47741 16.0004 4.62706 16.0004C3.77671 16.0004 3.08471 16.6734 3.08471 17.5004V19.5004C3.08471 19.9264 3.27904 20.3364 3.61836 20.6234C3.83223 20.8054 3.85383 21.1214 3.66772 21.3294C3.48058 21.5374 3.15463 21.5574 2.94281 21.3774C2.37934 20.8984 2.05647 20.2154 2.05647 19.5004V17.5004C2.05647 16.2924 2.94075 15.2834 4.11294 15.0514V13.0004C1.84157 13.0004 0 14.7914 0 17.0004V23.0004H17.48V17.0004C17.48 14.7914 15.6384 13.0004 13.3671 13.0004V19.0924C13.9645 19.2994 14.3953 19.8484 14.3953 20.5004C14.3953 21.3284 13.7043 22.0004 12.8529 22.0004C12.0016 22.0004 11.3106 21.3284 11.3106 20.5004C11.3106 19.8484 11.7414 19.2994 12.3388 19.0924V13.0004H11.3106C11.3106 14.1044 10.16 15.0004 8.74 15.0004ZM8.22745 1H9.25569V2H10.2839V3H9.25569V4H8.22745V3H7.19922V2H8.22745V1Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgADAPhysicianPortal',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>